import Vue from 'vue';
import axios from 'axios';
import { Message } from 'element-ui';
import store from '@/store';
import router from '@/router';
import qs from 'qs';
import { REQUEST_BASE_URL } from '@/api/baseAPi';

// 存储所有取消函数
const pendingRequests = [];

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    let Token = localStorage.getItem('at_token');
    if (Token) {
      config.headers['Authorization'] = process.env.VUE_APP_NAME === 'guojiao' ? Token : 'Bearer ' + Token;
    }

    if (config.method === 'get') {
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      };
    }

    // 设置取消请求
    config.cancelToken = new axios.CancelToken((cancel) => {
      pendingRequests.push(cancel);
    });
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export const requestInterceptor = (config) => {
  config.timeout = 6000000; // 设置超时时间 600s
  return config;
};

// 处理响应数据
export const responseSuccessInterceptor = (res) => {
  // 请求完成后从数组中移除取消函数
  const index = pendingRequests.findIndex(
    (cancel) => cancel.url === res.config.url,
  );
  if (index !== -1) {
    pendingRequests.splice(index, 1);
  }

  if (!res.headers) return res;
  //对响应数据做些事
  if (res.headers['content-type'] === 'application/octet-stream' || res.headers['content-type'] === 'application/pdf') {
    return res;
  } else if (
    res.headers['content-type'] ===
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ) {
    return res;
  } else {
    return res.data;
  }
};
export const responseFailureInterceptor = (error) => {
  if (error.response?.status) {
    let err;
    let msg =
      error.response && error.response.data && error.response.data.error
        ? error.response.data.error.message
        : error.response?.data.message || '';

    if (error.response.status === 429) {
      return Promise.reject(error);
    }

    switch (error.response.status) {
      case 400:
        err = `${msg}`;
        // store.commit('logout');
        // router.push({ name: 'login' });
        break;
      // 401: 未登录
      // 未登录则跳转登录页面，并携带当前页面的路径
      // 在登录成功后返回当前页面，这一步需要在登录页操作。
      case 401:
        // err = '用户没有权限（Token过期或错误）!';
        if (process.env.VUE_APP_NAME !== 'guojiao') {
          err = '尚未登录，请登录后访问';
          store.commit('logout');
          router.push({ name: 'login' });
        } else {
          err = '暂未登录或token已过期!';
        }

        // store.commit('logout');
        // window.location.href = store.state
        break;
      case 403:
        err = msg;
        store.commit('logout');
        router.push({ name: 'login' });
        break;
      // 404: 请求不存在
      case 404:
        err = '网络请求错误,未找到该资源!';
        break;
      case 405:
        err = '网络请求错误,请求方法未允许!';
        break;
      case 408:
        err = '网络请求超时!';
        break;
      case 500:
        err = '服务器错误,请联系管理员!';
        break;
      case 501:
        err = '网络未实现!';
        break;
      case 502:
        err = '网络错误!';
        break;
      case 503:
        err = '服务不可用，服务器暂时过载或维护!';
        break;
      case 504:
        err = '网络超时!';
        break;
      case 505:
        err = 'http版本不支持该请求!';
        break;
      default:
        err = '出错啦';
        break;
    }
    // resetMessage.error(err);
    Message.error(err);
    // console.error(err);
  }
  return Promise.reject(error);
};

// http request 拦截器
axios.interceptors.request.use(requestInterceptor);
// 返回状态判断、响应拦截器
axios.interceptors.response.use(
  responseSuccessInterceptor,
  responseFailureInterceptor,
);

// 配置baseURL
axios.defaults.baseURL = REQUEST_BASE_URL + (process.env.VUE_APP_NAME === 'guojiao' ? '/api-key' : '');

/**
 *  高端人才系统接口配置
 */
let talentAxios = axios.create();
talentAxios.defaults.baseURL = '/talent-attract-api'; // 代理
talentAxios.interceptors.request.use(
  (config) => {
    config.timeout = 6000000; // 设置超时时间 600s

    let TalentToken = localStorage.getItem('TalentToken');
    if (TalentToken) {
      config.headers['Authorization'] = TalentToken;
    }

    if (config.method === 'get') {
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      };
    }

    // 设置取消请求
    config.cancelToken = new axios.CancelToken((cancel) => {
      pendingRequests.push(cancel);
    });

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
talentAxios.interceptors.request.use(requestInterceptor);
talentAxios.interceptors.response.use(
  responseSuccessInterceptor,
  responseFailureInterceptor,
);

/**
 *  科研助手接口配置
 */
let researchAxios = axios.create();
researchAxios.defaults.baseURL = '/research-assistant-api'; // 代理
researchAxios.interceptors.request.use(
  (config) => {
    config.timeout = 600000; // 设置超时时间 600s

    if (config.method === 'get') {
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      };
    }

    // 设置取消请求
    config.cancelToken = new axios.CancelToken((cancel) => {
      pendingRequests.push(cancel);
    });

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
researchAxios.interceptors.request.use(requestInterceptor);
researchAxios.interceptors.response.use(
  responseSuccessInterceptor,
  responseFailureInterceptor,
);

// 全局方法 - 取消所有pending请求
Vue.prototype.$cancelAllRequests = (message = '取消所有请求') => {
  pendingRequests.forEach((cancel) => cancel(message));
  pendingRequests.length = 0;
};

export { axios, talentAxios, researchAxios };
